module.exports = __webpack_public_path__ + "img/resume.9ad9222a.jpg";